module.exports = __webpack_public_path__ + "img/xandr.580f87b.png";